/** Ism-familiya bosh harflari — lime kvadrat (sayt kabinetidagi kabi). */
export function Avatar({
  firstName,
  lastName,
  className = 'h-14 w-14 text-lg',
}: {
  firstName: string;
  lastName?: string | null;
  className?: string;
}) {
  const initials = [firstName, lastName]
    .filter(Boolean)
    .map((s) => s![0])
    .join('')
    .toUpperCase();
  return (
    <span
      className={`grid shrink-0 place-items-center rounded-2xl bg-lime font-display font-bold text-lime-ink shadow-[0_8px_24px_-10px_var(--glow)] ${className}`}
    >
      {initials || '👤'}
    </span>
  );
}
